import { S200UKI_CONNECTOR_BASE_URL } from 'constants/Environment';
import { createInstance } from '../axios';

const normalizeBaseUrl = (url) => url.replace(/\/$/, '');

export const connectorClient = createInstance({
    baseURL: normalizeBaseUrl(S200UKI_CONNECTOR_BASE_URL),
});
